<template>
  <div id="easy-access-navbar-mobile">
    <ul class="menu-list">
      <li id="header-logo">
        <!-- sticky-logo -->
        <div class="sticy-logo">
          <router-link to="/" exact>
            <img
              src="/img/nutron-logo.png"
              alt="nutron-logo"
              class="img-fluid mobile-logo"
            />
          </router-link>
        </div>
      </li>
      <div
        :name="index"
        v-for="(category, index) in getCategories"
        :key="category.id"
      >
        <el-collapse
          v-if="category.parent_id === null && category.sub_categories.length"
        >
          <el-collapse-item name="1">
            <template slot="title">
              <span class="d-block">{{ category.name }}</span>
            </template>
            <div class="item-sub-menu">
              <div
                v-for="sub_category in category.sub_categories"
                :key="sub_category.id"
              >
                <router-link
                  v-if="sub_category.products_count"
                  :to="'/products/' + sub_category.slug"
                  >{{ sub_category.display_name }}</router-link
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <router-link
          class="el-collapse-item__header"
          v-if="category.products_count"
          :to="'/products/' + category.slug"
          >{{ category.display_name }}</router-link
        >
      </div>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      stickyHeading: false
    };
  },
  computed: {
    ...mapGetters("categories", ["getCategories"])
  },
  methods: {
    async fetchCategories() {
      await this.$store.dispatch("categories/getCategories");
    },
    handleScroll() {
      const headerTop = document.getElementById("header-logo");
      const sticky = 400;
      if (window.pageYOffset > sticky) {
        headerTop.classList.add("sticky");
      } else {
        headerTop.classList.remove("sticky");
      }
    }
  },
  async created() {
    await this.fetchCategories();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.el-dropdown-menu {
  padding: 0;
}
.sticky {
  .menu-list {
    z-index: 3000;
  }
}
#easy-access-navbar-mobile {
  border-top: 1px dashed #dddddd;
  padding: 1.5em 1em 2em 0;
  z-index: 12000;
  margin-top: 1.5em;
  .easy-access-heading {
    font-size: 1.875em;
    line-height: 2.125em;
    text-transform: uppercase;
    font-weight: normal;
    padding-bottom: 0;
  }
  .el-collapse {
    border: none;
  }
  .menu-list {
    display: block;
    padding-left: 30px;
    li {
      display: block;
      a {
        font-size: 0.9em;
        display: block;
        color: #000000;
        text-transform: uppercase;
        padding: 7px 0px;
      }
      span {
        font-size: 0.9em;
        display: block;
        color: #000000;
        text-transform: uppercase;
        padding: 7px 0px;
      }

      p {
        color: #11233f;
        text-transform: uppercase;
        font-weight: 600;
        margin-right: 1.875em;
      }
    }
  }
}
.sticy-logo {
  display: none;
}
.sticky {
  padding: 5px 0 !important;
}
.sticky .easy-access-heading {
  display: none;
}
.sticky .sticy-logo {
  display: block;
  margin-right: 25px;
  text-transform: uppercase;
}
.sticky .menu-list li a {
  font-size: 0.9em !important;
}
.el-dropdown {
  font-size: inherit;
}
</style>

<style lang="scss">
#easy-access-navbar-mobile {
  .mobile-logo {
    margin-left: 20px;
  }
  .el-collapse-item__header {
    background-color: transparent;
    border: none;
    font-size: 1em;
    display: block;
    text-transform: uppercase;
    padding: 7px 0px;
    font-weight: 300;
    height: auto;
    line-height: 1.4;
    .d-block {
      display: inline-block;
      width: calc(100% - 30px);
    }
  }
  .el-collapse-item__wrap {
    background-color: transparent;
  }
  .el-collapse-item__content {
    font-size: 1em;
    margin-top: 10px;
    .item-sub-menu {
      a {
        font-size: 0.85em;
        display: block;
        padding: 7px 0px 7px 15px;
        font-weight: 300;
        height: auto;
        line-height: 1.4;
        color: #11233f;
      }
    }
  }
}
</style>
